/**
 * Keeps a cutlist's sheet line item and its Machining Charge line item(s)
 * linked in the cart. Machining lines have no remove/quantity controls of
 * their own (see sections/main-cart.liquid and snippets/mini-cart.liquid),
 * so the only way either side of the pairing disappears is the sheet line
 * being removed - when that happens, this removes the paired machining
 * line(s) too, so a machining charge can never survive on its own.
 *
 * Line items are matched by their shared `_cutlist_ref` property (set by
 * assets/product-cutlist-optimiser.js) rendered into `data-cutlist-ref` on
 * each line item's row, alongside `data-cutlist-role` ("sheet"/"machining")
 * and `data-line-key` (the line item's stable Shopify key).
 *
 * The theme's own remove/decrease-quantity controls address lines by
 * position (`line=N`), which shifts as soon as any other line is added or
 * removed. If we let the theme remove the sheet line by position while we
 * remove the machining line(s) by key in parallel, whichever finishes first
 * shifts the other's position out from under it - so instead of just adding
 * our own removal on top, we take over the sheet line's removal entirely
 * (stopping the theme's own handler) and remove both sides by key.
 */
(function () {
  'use strict';

  function cartChangeUrl() {
    return (window.routes && window.routes.cartChangeUrl) || '/cart/change';
  }

  function removeByKey(key) {
    return fetch(cartChangeUrl() + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var control = event.target.closest('[data-action="decrease-quantity"]');
      if (!control || control.getAttribute('data-quantity') !== '0') return;

      var row = control.closest('[data-cutlist-role]');
      if (!row || row.getAttribute('data-cutlist-role') !== 'sheet') return;

      var ref = row.getAttribute('data-cutlist-ref');
      var sheetKey = row.getAttribute('data-line-key');
      if (!ref || !sheetKey) return;

      // Take full ownership of this removal so the theme's own
      // position-based handler never runs alongside ours.
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

      var pairedRows = document.querySelectorAll('[data-cutlist-role="machining"][data-cutlist-ref="' + ref + '"]');
      var keys = [sheetKey];
      for (var i = 0; i < pairedRows.length; i++) {
        var key = pairedRows[i].getAttribute('data-line-key');
        if (key && keys.indexOf(key) === -1) keys.push(key);
      }

      document.dispatchEvent(new CustomEvent('theme:loading:start'));

      // Remove one line at a time rather than firing every removal
      // concurrently. A quantity change just made a moment ago (e.g.
      // decreasing back down to the floor) may still be settling on
      // Shopify's side when Remove is clicked straight after - queuing our
      // own removals strictly one-after-another avoids adding another
      // concurrent write into that window, which is what let one removal
      // (usually the machining line) occasionally get silently dropped.
      var chain = Promise.resolve();
      keys.forEach(function (key) {
        chain = chain.then(function () {
          return removeByKey(key);
        });
      });

      chain
        .catch(function () {})
        .then(function () {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
        });
    },
    true
  );

  // The decrease button is disabled server-side once a sheet line's
  // quantity reaches `data-cutlist-min-qty` - the number of sheets its
  // submitted cut list actually needs - but the quantity box itself is
  // still a free-text field, so typing a value below that floor and
  // blurring/pressing Enter would otherwise still send it. Increases, and
  // decreases that stay at or above the floor, are left untouched.
  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;
      if (!input.classList || !input.classList.contains('quantity-selector__value')) return;

      var row = input.closest('[data-cutlist-role]');
      if (!row || row.getAttribute('data-cutlist-role') !== 'sheet') return;

      var current = parseInt(input.getAttribute('data-current-value'), 10);
      var minQty = parseInt(row.getAttribute('data-cutlist-min-qty'), 10);
      var typed = parseInt(input.value, 10);
      if (isNaN(current) || isNaN(minQty)) return;

      if (isNaN(typed) || typed < minQty) {
        input.value = current;
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      }
    },
    true
  );
})();
